// Süper admin › Tahsilat › Ayarlar › Ürünler kullanım rehberi. Metinler 'guides' çeviri alanında.
import type { TFunction } from 'i18next';
import type { GuideContent } from '../../components/common/UsageGuideDialog';

const G = 'superadmin.billingProducts';

export const billingProductsGuide = (t: TFunction): GuideContent => ({
  layout: 'list',
  title: t(`${G}.title`, 'Tahsilat Ürünleri nasıl kullanılır?'),
  intro: t(`${G}.intro`, 'Tahsilat kayıtlarında tekrar tekrar kullandığınız ürün ve hizmetleri liste fiyatıyla burada tutarsınız. Haritada bir bölgeye tıklayarak o adıma geçebilirsiniz.'),
  regionLabels: {
    header: t(`${G}.regions.header`, 'Ürünler'),
    toolbar: t(`${G}.regions.toolbar`, 'Yeni Ürün'),
    table: t(`${G}.regions.table`, 'Ürün listesi'),
    pagination: t(`${G}.regions.pagination`, 'Sayfalama'),
  },
  steps: [
    {
      region: 'header',
      title: t(`${G}.s1.title`, '1. Liste fiyatı ve kalem farkı'),
      text: t(`${G}.s1.text`, 'Liste fiyatı, tahsilat kaleminin başlangıç tutarıdır. Tahsilatta ürünü seçince bu fiyat gelir; kalemde fark yazarak artırıp azaltırsınız. Örnek: Pavo 4.000 TL. Satışta 6.000 istiyorsanız kalemde farka 2.000, 3.000 istiyorsanız −1.000 yazılır.'),
      tips: [
        t(`${G}.s1.tip1`, 'Tahsilat tutarları KDV dahildir; faturada KDV hariç tutar bu tutardan hesaplanır.'),
      ],
    },
    {
      region: 'toolbar',
      title: t(`${G}.s2.title`, '2. Yeni Ürün ekleyin'),
      text: t(`${G}.s2.text`, '"Yeni Ürün" penceresinde Ürün adı (zorunlu), Tür (Cihaz, Yazarkasa, Sözleşme, Diğer), Liste fiyatı (TRY), KDV % ve isterseniz Açıklama girin.'),
      tips: [
        t(`${G}.s2.tip1`, 'Fiyatı Türkçe yazabilirsiniz: "4.000" dört bin, "4.000,50" dört bin lira elli kuruş olarak okunur. Fiyat ve KDV oranı negatif olamaz.'),
        t(`${G}.s2.tip2`, 'Aktif anahtarı kapalı olan ürün yeni tahsilat açarken listede çıkmaz.'),
      ],
    },
    {
      region: 'table',
      title: t(`${G}.s3.title`, '3. Ürünleri düzenleyin veya silin'),
      text: t(`${G}.s3.text`, 'Listede ürün, tür, liste fiyatı, KDV % ve durum görünür. Satıra tıklayınca ya da kalem simgesiyle düzenleyin; çöp kutusu simgesi ürünü siler. Eski tahsilat kayıtlarındaki kalemler silmeden etkilenmez.'),
      tips: [
        t(`${G}.s3.tip1`, 'Liste fiyatını değiştirmek yalnız bundan sonra seçilecek kalemleri etkiler.'),
        t(`${G}.s3.tip2`, 'Hazır ürünler (Yazarkasa GMÜ yenileme, Panel / lisans yenileme, Ek cihaz ve sık kullanılan yazarkasa modelleri) listede yoksa 0 fiyatla kendiliğinden eklenir; fiyatlarını buradan güncelleyin. Bunlardan birini silerseniz liste yeniden açılınca 0 fiyatla tekrar eklenir; kullanmadıklarınızı silmek yerine Pasif yapın.'),
      ],
    },
    {
      region: 'pagination',
      title: t(`${G}.s4.title`, '4. Sayfalar arasında gezinin'),
      text: t(`${G}.s4.text`, 'Liste uzunsa alttaki sayfalamayı kullanın. Sol üstteki mavi kutu kayıtlı ürün sayısını gösterir.'),
    },
  ],
});
